import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Res } from '../models';
import { ApiBasicService } from './api-basic.service';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class ApiPresetsService {

  constructor(
    private apiBasic: ApiBasicService,
    private api: ApiService,
    ) 
  { }


  getAttrPresentTypeId(params): Observable<Res> {

    return this.apiBasic.getAttrPresentTypeId(params);
    // return this.api.post('references/' + moduleName, params, 'private');
  }


  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
   getReferences(params: any, moduleName): Observable<Res> {

    return this.apiBasic.getReferences(params, moduleName);
  }


  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  getList(params: any): Observable<Res> {

    return this.apiBasic.getList(params, 'attrs_presets');
  }

  /**
   * 
   * @param id string
   * @returns Observable<Res>
   */
   info(id: string): Observable<Res> {

    return this.apiBasic.getInfo('attrs_presets', id);
  }


  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  create(params: any): Observable<Res> {

    return this.apiBasic.create('attrs_presets', params);
  }

  /**
   * 
   * @param id string
   * @returns Observable<Res>
   */
  edit(id: string): Observable<Res> {

    return this.apiBasic.edit('attrs_presets', id);
  }

  /**
  * 
  * @param params any
  * @returns Observable<Res>
  */
  update(params: any): Observable<Res> {

    return this.apiBasic.update('attrs_presets', params);
  }

  /**
   * 
   */
  delete(params: any): Observable<Res> {

    return this.apiBasic.delete('attrs_presets', params);
  }


  /**
   * 
   * @param objectName 
   * @param objectId 
   * @returns 
   */
  getUserOrgs(): Observable<Res> {

    return this.api.post('references/user_in_orgs', '', 'private');
  }
}
